import { useState } from "react";
import NavItem from "./NavItem";
import { getAllRouteData } from "../../utils/route.utils";
import styled from "styled-components";
import { arrayMap } from "../../utils/array.utils";

const Navbar = ({ collapse, collapseToggle }) => {
  const [openIndex, setOpenIndex] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);
  const data = getAllRouteData();
  return (
    <NavbarContainer className="nav flex-column">
      {arrayMap(data, (item, index) => (
        <NavItem
          key={index + 1}
          index={index + 1}
          data={item}
          openIndex={openIndex}
          setOpenIndex={setOpenIndex}
          activeIndex={activeIndex}
          setActiveIndex={setActiveIndex}
          collapse={collapse}
          collapseToggle={collapseToggle}
        />
      ))}
    </NavbarContainer>
  );
};

export default Navbar;

const NavbarContainer = styled.ul`
  li a {
    color: var(--main-color) !important;

    &:hover {
      color: var(--main-nav-hover-color) !important;
      background-color: var(--main-nav-bg-hover-color) !important;
    }
  }

  li a.active {
    color: var(--main-nav-hover-color) !important;
    background-color: var(--main-nav-bg-hover-color) !important;
  }

  li ul li a.active {
    color: var(--main-nav-hover-color) !important;
    background-color: transparent !important;
  }

  li ul li a:hover {
    color: var(--main-nav-hover-color) !important;
    background-color: var(--main-nav-bg-hover-color) !important;
  }
`;
